import { useRef, useState } from 'react';
import { Button, Classes, Dialog, DialogBody } from '@blueprintjs/core';
import { SoundSettings } from './SoundSettings';

export function GlobalSettingsButton() {
  const [open, setOpen] = useState(false);
  const trigger = useRef<HTMLButtonElement>(null);
  return (
    <>
      <Button
        ref={trigger}
        icon="cog"
        variant="minimal"
        aria-haspopup="dialog"
        aria-expanded={open}
        onClick={() => setOpen(true)}
      >
        Settings
      </Button>
      <Dialog
        isOpen={open}
        onClose={() => setOpen(false)}
        onClosed={() => trigger.current?.focus({ preventScroll: true })}
        title="Settings"
        aria-label="Settings"
        className={Classes.DARK}
        style={{ width: 420, maxWidth: 'calc(100vw - 24px)' }}
      >
        <DialogBody style={{ maxHeight: 'calc(100dvh - 120px)', overflowY: 'auto' }}>
          <p>
            Sound preferences apply everywhere in DigiTiles and are saved in this browser.
          </p>
          <SoundSettings />
          <p>
            Appearance, shortcuts, and project controls are available in editor settings.
          </p>
        </DialogBody>
      </Dialog>
    </>
  );
}
